'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _tooltip = require('../tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var cx = _bind2.default.bind(_style2.default);

var FormGroup = function FormGroup(_ref) {
  var children = _ref.children,
      appearance = _ref.appearance,
      direction = _ref.direction,
      indentation = _ref.indentation,
      border = _ref.border,
      centered = _ref.centered,
      label = _ref.label,
      caption = _ref.caption,
      action = _ref.action,
      tooltip = _ref.tooltip,
      rest = _objectWithoutProperties(_ref, ['children', 'appearance', 'direction', 'indentation', 'border', 'centered', 'label', 'caption', 'action', 'tooltip']);

  return _react2.default.createElement(
    'div',
    _extends({}, rest, {
      className: cx('xsui-form-group', 'xsui-form-group--' + appearance, 'xsui-form-group--direction-' + direction, 'xsui-form-group--indentation-' + indentation, border && 'xsui-form-group--border', border && 'xsui-form-group--border-' + (border === true ? 'md' : border), centered && 'xsui-form-group--centered') }),
    label && _react2.default.createElement(
      'div',
      { className: cx('xsui-form-group__label') },
      label,
      tooltip && _react2.default.createElement(_tooltip2.default, { label: tooltip, offset: 'left' }),
      action && _react2.default.createElement(
        'div',
        { className: cx('xsui-form-group__label__action') },
        action
      )
    ),
    _react2.default.createElement(
      'div',
      { className: cx('xsui-form-group__entry') },
      children
    ),
    caption && _react2.default.createElement(
      'div',
      { className: cx('xsui-form-group__caption') },
      caption
    )
  );
};

FormGroup.propTypes = {
  children: _propTypes2.default.any.isRequired,
  appearance: _propTypes2.default.oneOf(['primary', 'secondary']),
  direction: _propTypes2.default.oneOf(['column', 'row']),
  indentation: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xlg', 'xxlg']),
  border: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg'])]),
  centered: _propTypes2.default.bool,
  label: _propTypes2.default.node,
  caption: _propTypes2.default.node,
  action: _propTypes2.default.node,
  tooltip: _propTypes2.default.node
};

FormGroup.defaultProps = {
  appearance: 'primary',
  direction: 'column',
  indentation: 'md',
  border: false,
  centered: false,
  label: null,
  action: null,
  tooltip: null
};

exports.default = FormGroup;